module.exports = __webpack_public_path__ + "static/media/intro-1.8204b32d.svg";